import { compose, withHandlers, withProps } from 'recompose'
import { connect } from 'react-redux'
import DetailsLinks from './DetailsLinks'
import withRequestApptClick from 'components/common/hoc/withRequestApptClick'
import { makeActiveVehicle } from 'components/MyGarage2.0/components/BOTGarageVehicles/actions'
import { QUICK_APPOINTMENT_PAGE } from 'constant'

const withNavigation = withHandlers({
  navigateToQuoteHandler: ({ onClick, isActiveVehicle, makeActiveVehicle, userVehicleId }) => e =>
    isActiveVehicle ? onClick(e) : makeActiveVehicle({ userVehicleId, url: QUICK_APPOINTMENT_PAGE })
})

export default compose(
  connect(null, { makeActiveVehicle }),
  withProps(() => ({ navigateToQuickApptPage: true })),
  withRequestApptClick,
  withNavigation
)(DetailsLinks)
